var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 10.9446L4.66667 8.27791M4.66667 8.27791L7.33333 5.61125M4.66667 8.27791L14 8.27791M10.6667 10.9446V11.6112C10.6667 12.7158 9.77124 13.6112 8.66667 13.6112H4C2.89543 13.6112 2 12.7158 2 11.6112V4.94458C2 3.84001 2.89543 2.94458 4 2.94458H8.66667C9.77124 2.94458 10.6667 3.84001 10.6667 4.94458V5.61125",
    stroke: "#3A434B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a5dbd97e70061b64696c6d82946f4ee9.svg";
export { ForwardRef as ReactComponent };